

import axios from "axios";
import { userDataConnect } from "./userDataConnect";
import { getMemoryAccessToken, setMemoryAccessToken } from "../stores/authStorage";

const AUTH_API_ADDRESS = process.env.REACT_APP_AUTH_API_ADDRESS;

const axiosAuthInterceptor = axios.create({
    baseURL: AUTH_API_ADDRESS,
    withCredentials: true,
    headers: { "Content-Type": "application/json" },
});

let isRefreshing = false,
    queue = [];

axiosAuthInterceptor.interceptors.request.use((config) => {
    const token = getMemoryAccessToken();
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

axiosAuthInterceptor.interceptors.response.use(
    (res) => res,
    async (err) => {
        const orig = err.config;
        if (err.response?.status === 401 && !orig._retry) {
            orig._retry = true;
            if (isRefreshing) {
                return new Promise((res, rej) => queue.push({ res, rej })).then(
                    (newToken) => {
                        orig.headers.Authorization = `Bearer ${newToken}`;
                        return axiosAuthInterceptor(orig);
                    },
                );
            }
            isRefreshing = true;
            try {
                const reissueAccessTokenResponse =
                    await userDataConnect().reissueAccessToken();
                const newToken =
                    reissueAccessTokenResponse.data?.data?.accessToken;
                setMemoryAccessToken(newToken);

                queue.forEach((p) => p.res(newToken));
                queue = [];
                orig.headers.Authorization = `Bearer ${newToken}`;
                return axiosAuthInterceptor(orig);
            } catch (e) {
                queue.forEach((p) => p.rej(e));
                queue = [];
                setMemoryAccessToken(null);
                return Promise.reject(e);
            } finally {
                isRefreshing = false;
            }
        }
        return Promise.reject(err);
    },
);

export { axiosAuthInterceptor };